<div mat-dialog-actions class="container-modal-header">
  <div class="icon-help d-flex align-items-center">
      <span class="material-icons">
          help_outline
      </span>
      <p>Ajuda</p>
  </div>
  <span class="material-icons icon-close"  [mat-dialog-close]="true">
      close
  </span>
</div>

<div class="container">
  <div class="row">
    <div class="col">
      <h1>
        Como tirar a selfie pelo celular?
    </h1>
    </div>
  </div>
  <div class="row">
      <div class="col"></div>
      <div class="col-10">
        <div class="row">
          <div class="col-md-4 col-sm-10 align-items-center justify-content-center text-center">
            <div class="box-item">
              <!-- <div class="row">
                <div class="col">
                
                </div>
              </div> -->
              <img class="rounded mx-auto d-block" src="../../../../assets/svg/smartphone-with-qr-code.svg" alt="Ícone smartphone com qr code na tela"/>
              <p>Abra a câmera ou leitor de QR Code do seu celular e aponte para a imagem (QR Code).</p>
  
              <!-- <div class="row">
                <div class="col">
                </div>
              </div> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-10">
            <div class="box-item align-items-center justify-content-center">
                <!-- <div class="row">
                  <div class="col">
                  </div>
                </div> -->
                <img class="rounded mx-auto d-block" src="../../../../assets/svg/smartphone-with-person.svg" alt="Ícone smartphone com qr code na tela"/>
                <p>Você receberá um link para acessar o sistema de reconhecimento facial. Clique nele.</p>
                <!-- <div class="row">
                  <div class="col">
                  </div>
                </div> -->
            </div>
        </div>
        <div class="col-md-4 col-sm-10">
            <div class="box-item align-items-center justify-content-center">
              <!-- <div class="row">
                <div class="col">
                </div>
              </div> -->
              <img class="rounded mx-auto d-block" src="../../../../assets/svg/confirm-help-photo.svg" alt="Ícone smartphone com qr code na tela"/>
              <p>Tire sua foto seguindo as dicas e pronto! O sistema fará a validação automaticamente.</p>
              <!-- <div class="row">
                <div class="col">
                </div>
              </div> -->
            </div>
        </div>
        </div>
      </div>
      <div class="col"></div> 
  </div>

  <hr>

  <div class="row">
    <div class="col mb-4 pb-3">
      <p>Para que o sistema reconheça o seu rosto na foto, siga as dicas abaixo:</p>
    </div>
  </div>

  <div class="row">
      <div class="col"></div>
      <div class="col-10">
        <div class="row">
          <div class="col-md-3">
            <div class="box-item align-items-center justify-content-center text-center">
                <img class="rounded mx-auto d-block" src="../../../../assets/svg/no-glasses.svg" alt="Óculos"/>
                <p>Remova seus óculos</p>
            </div>
        </div>
        <div class="col-md-3 col-sm-10">
            <div class="box-item align-items-center justify-content-center text-center">
              <img class="rounded mx-auto d-block" src="../../../../assets/svg/no-pead-cap.svg" alt="Icone boné proibido">
              <p>Tire chapéus, bonés etc</p>
            </div>
        </div>
        <div class="col-md-3 col-sm-10">
            <div class="box-item align-items-center justify-content-center text-center">
                <img class="rounded mx-auto d-block" src="../../../../assets/svg/no-mask.svg" alt="Icone mascára">
                <p>Remova sua máscara</p>
            </div>
        </div>
        <div class="col-md-3 col-sm-10">
            <div class="box-item align-items-center justify-content-center">
                <img class="rounded mx-auto d-block" src="../../../../assets/svg/no-another-photo.svg" alt="">
                <p>Não tire foto de outra foto</p>
            </div>
        </div>
        </div>
      </div>
      <div class="col"></div>
  </div>

</div>

<!-- <div class="container-modal-header">
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="icon-help">
            <span class="material-icons">
                help_outline
            </span>
            <p>Ajuda</p>
        </div>
        <span class="material-icons icon-close"  (click)="onNoClick()">
            close
        </span>
        </div>
      </div>
    </div>
  </div>
</div> -->